export default __webpack_public_path__ + "static/parent-4557fa3094119fc7b5d51470d7d0411f.svg";